import React from 'react';
import styled, { css } from 'styled-components';
import { SUB_CATEGORY_FONT_COLOUR } from '../../enums';
import { theme } from '../../theme';
import { rgba } from 'polished';

export interface SubCategoryItemProps {
  label: string;
  name: string;
  fontColour: SUB_CATEGORY_FONT_COLOUR;
  image: any;
  openInNewTab?: boolean;
  url?: string;
}

const SharedStyles = css<{ $fontColour: SUB_CATEGORY_FONT_COLOUR }>`
  text-decoration: none;

  ${({ $fontColour }) => css`
    color: ${$fontColour === SUB_CATEGORY_FONT_COLOUR.WHITE
      ? 'white'
      : 'black'};
  `}
`;

const Container = styled.section`
  width: 228px;
  min-width: 228px;
  height: 94px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
`;

const BackgroundImage = styled.a<{
  $image: any;
  $fontColour: SUB_CATEGORY_FONT_COLOUR;
}>`
  width: 228px;
  height: 94px;
  margin: 0;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  z-index: 1;

  ${({ $image }) => css`
    background-image: url(${$image.desktopAsset.url});
  `}

  &::before {
    content: '';
    position: absolute;
    border-radius: 12px;
    width: 100%;
    height: 100%;
    background: ${rgba(theme.colors.neutrals.transparentGrays[1], 0.4)};
    z-index: 2;
    transition: all 150ms ease;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }

  &:hover {
    &::before {
      width: 220px;
      height: 86px;
    }
  }

  ${SharedStyles}
`;

const Heading = styled.h4<{
  $fontColour: SUB_CATEGORY_FONT_COLOUR;
}>`
  z-index: 3;
  margin: 0 ${theme.spacings[3].px};
  ${SharedStyles}
`;

export const SubCategoryItem = ({
  image,
  name,
  fontColour,
  url,
  openInNewTab,
}: SubCategoryItemProps): JSX.Element => (
  <Container>
    <BackgroundImage
      $image={image}
      $fontColour={fontColour}
      href={url || '#'}
      target={openInNewTab ? '_blank' : '_self'}
      rel="noreferrer"
    >
      <Heading $fontColour={fontColour}>{name}</Heading>
    </BackgroundImage>
  </Container>
);
